export const UserflowIds = {
    joinWorkspace: {
        requestJoinButton: "join-workspace-request-join-button",
        createButton: "join-workspace-create-button",
        createNewButton: "join-workspace-create-new-button",
    },
};
